<template>
  <div class="container">
    <div class="school-body-stu-works">
      <el-row>
        <el-col :span="24">
          <div class="classwrapper">
            <el-row>
              <el-col :span="24">
                <div class="coursework">
                  <el-tabs v-model="activeName" @tab-click="handleClickTab">
                    <!-- <el-tab-pane label="课堂作品" name="first">
                      <el-form
                        ref="form"
                        :model="CourseworkForm"
                        :inline="true"
                        size="mini"
                      >
                        <el-form-item label="所属科目">
                          <el-select
                            v-model="CourseworkForm.subject_code"
                            placeholder="请选择科目"
                            style="width: 100px"
                            filterable
                            @change="stuGetTchWorkList"
                          >
                            <el-option
                              :label="item.name"
                              :value="item.code"
                              v-for="(item, index) of subjectList"
                              :key="index"
                            ></el-option>
                          </el-select>
                        </el-form-item>

                        <el-form-item label="作品名称">
                          <el-input
                            clearable
                            style="width: 200px"
                            v-model="CourseworkForm.title"
                            placeholder="请输入作品名称"
                          >
                          </el-input>
                        </el-form-item>

                        <el-form-item size="mini">
                          <el-button type="primary" @click="stuGetTchWorkList"
                            >查询</el-button
                          >
                        </el-form-item>
                      </el-form>

                      <el-row :gutter="20">
                        <el-col
                          :span="25"
                          v-for="item of StuCourseWorks"
                          :key="item.id"
                        >
                          <el-card shadow="never">
                            <div class="worklist">
                              <div
                                class="worklist_imgwrapper"
                                @click="LookMark(item)"
                              >
                                <el-image
                                  class="workimg"
                                  :src="item.covers"
                                  fit="fill"
                                ></el-image>
                              </div>

                              <div class="work_title">
                                <el-row>
                                  <el-col :span="17">
                                    <div>
                                      <el-tooltip
                                        class="item"
                                        effect="dark"
                                        :content="item.title"
                                        placement="top-start"
                                      >
                                        <span class="work_title_span">{{
                                          item.title.slice(0, 10)
                                        }}</span>
                                      </el-tooltip>
                                    </div>
                                  </el-col>
                                  <el-col :span="7">
                                    <div>
                                      <el-tag
                                        v-if="item.work_type == '1'"
                                        size="mini"
                                        style="margin-left: 10px"
                                        type="primary"
                                        effect="dark"
                                        >课堂</el-tag
                                      >

                                      <el-tag
                                        effect="dark"
                                        type="warning"
                                        v-else
                                        size="mini"
                                        style="margin-left: 10px"
                                      >
                                        作业</el-tag
                                      >
                                    </div>
                                  </el-col>
                                </el-row>
                              </div>

                              <div>
                                <el-row>
                                  <el-col :span="4">
                                    <div class="work_stuinfo">
                                      <el-avatar
                                        size="small"
                                        class="work_stuinfo_avatar"
                                        :src="
                                          $store.state.user.userInfo.headimgUrl
                                        "
                                      ></el-avatar>
                                    </div>
                                  </el-col>

                                  <el-col :span="8">
                                    <div class="work_stuinfo_name">
                                      <span class="work_stuinfo_name_span">{{
                                        $store.state.user.userInfo.stuUserInfo
                                          .realName
                                      }}</span>
                                    </div>
                                  </el-col>

                                  <el-col :span="12">
                                    <div
                                      style="text-align: right"
                                      class="work_stuinfo_name"
                                    >
                                      <span
                                        v-if="item.is_marking"
                                        style="
                                                      margin-right: 10px;
                                                      cursor: pointer;
                                                      color: #67c23a;
                                                    "
                                        class="
                                                      work_stuinfo_name_span
                                                      el-icon-s-custom
                                                    "
                                        @click="LookMark(item)"
                                        >已评</span
                                      >
                                      <span
                                        v-else
                                        style="
                                                      margin-right: 10px;
                                                      cursor: pointer;
                                                      color: #909399;
                                                    "
                                        class="
                                                      work_stuinfo_name_span
                                                      el-icon-s-custom
                                                    "
                                        >未评</span
                                      >
                                    </div>
                                  </el-col>
                                </el-row>
                              </div>
                            </div>
                          </el-card>
                        </el-col>
                      </el-row>

                      <div style="margin: 20px; text-align: right">
                        <el-pagination
                          @current-change="handleCurrentChange"
                          :current-page="page_no"
                          :page-size="page_size"
                          layout="total, prev, pager, next, jumper"
                          :total="total"
                        >
                        </el-pagination>
                      </div>
                    </el-tab-pane> -->

                    <el-tab-pane label="自由创作" name="second">
                      <el-form ref="form" :model="FreeworkForm" :inline="true" size="mini">
                        <el-form-item label="所属科目">
                          <el-select v-model="FreeworkForm.subject_code" placeholder="请选择科目" style="width: 100px" filterable @change="getWorkList">
                            <el-option :label="item.name" :value="item.code" v-for="(item, index) of subjectList" :key="index"></el-option>
                          </el-select>
                        </el-form-item>

                        <el-form-item label="作品名称">
                          <el-input clearable style="width: 200px" v-model="FreeworkForm.title" placeholder="请输入作品名称">
                          </el-input>
                        </el-form-item>

                        <el-form-item size="mini">
                          <el-button type="primary" @click="getWorkList">查询</el-button>
                        </el-form-item>
                      </el-form>

                      <el-row :gutter="20" v-if="FreeWorkList.join('') !== ''">
                        <el-col :span="25" v-for="item of FreeWorkList" :key="item.id">
                          <el-card shadow="never">
                            <div class="worklist">
                              <div class="worklist_imgwrapper" @click="LookWork(item)">
                                <el-image class="workimg" :src="item.covers" fit="fill"></el-image>
                              </div>

                              <div class="work_title">
                                <el-row>
                                  <el-col :span="17">
                                    <div>
                                      <el-tooltip class="item" effect="dark" :content="item.title" placement="top-start">
                                        <span class="work_title_span">{{
                                          item.title.slice(0, 10)
                                        }}</span>
                                      </el-tooltip>
                                    </div>
                                  </el-col>
                                  <el-col :span="7">
                                    <div>
                                      <el-tag v-if="item.work_type == '1'" size="mini" type="info" effect="dark">未发布
                                      </el-tag>
                                      <el-tag type="primary" effect="dark" v-else-if="item.work_type == '2'" size="mini">已发布</el-tag>
                                    </div>
                                  </el-col>
                                </el-row>

                                <span style="margin-left: 5px" class="el-icon-thumb">
                                  <span style="margin-left: 5px">{{
                                    item.zan
                                  }}</span>
                                </span>
                                <span style="margin-left: 10px" class="el-icon-view"><span style="margin-left: 5px">{{
                                    item.looks
                                  }}</span></span>
                              </div>

                              <div>
                                <el-row>
                                  <el-col :span="4">
                                    <div class="work_stuinfo">
                                      <el-avatar size="small" class="work_stuinfo_avatar" :src="item.headImgUrl">
                                      </el-avatar>
                                    </div>
                                  </el-col>

                                  <el-col :span="8">
                                    <div class="work_stuinfo_name">
                                      <span class="work_stuinfo_name_span">{{
                                        item.name
                                      }}</span>
                                    </div>
                                  </el-col>

                                  <el-col :span="12">
                                    <div style="text-align: right" class="work_stuinfo_name">
                                      <span style="
                                                      margin-right: 20px;
                                                      cursor: pointer;
                                                      font-size: 16px;
                                                    " class="
                                                      work_stuinfo_name_span
                                                      el-icon-edit
                                                    " @click="EditCode(item)"></span>

                                      <span slot="reference" style="
                                                      margin-right: 10px;
                                                      cursor: pointer;
                                                      font-size: 16px;
                                                    " class="
                                                      work_stuinfo_name_span
                                                      el-icon-delete
                                                    " @click="deleteWork(item.id)">
                                      </span>
                                    </div>
                                  </el-col>
                                </el-row>
                              </div>
                            </div>
                          </el-card>
                        </el-col>
                      </el-row>

                      <wgStuEmpty v-else />

                      <div style="margin: 20px; text-align: right">
                        <el-pagination @current-change="handleCurrentChange1" :current-page="page_no1" :page-size="page_size1" layout="total, prev, pager, next, jumper" :total="total1">
                        </el-pagination>
                      </div>
                    </el-tab-pane>

                    <el-tab-pane v-if="zone_auth" label="点赞" name="third">
                      <el-form ref="form" :model="ZanworkForm" :inline="true" size="mini">
                        <el-form-item label="所属科目">
                          <el-select v-model="ZanworkForm.subject_code" placeholder="请选择科目" style="width: 100px" filterable @change="getUserZanWorkList">
                            <el-option :label="item.name" :value="item.code" v-for="(item, index) of subjectList" :key="index"></el-option>
                          </el-select>
                        </el-form-item>

                        <el-form-item label="作品名称">
                          <el-input clearable style="width: 200px" v-model="ZanworkForm.title" placeholder="请输入作品名称">
                          </el-input>
                        </el-form-item>

                        <el-form-item size="mini">
                          <el-button type="primary" @click="getUserZanWorkList">查询</el-button>
                        </el-form-item>
                      </el-form>

                      <el-row :gutter="20" v-if="ZanWorkList.join('') !== ''">
                        <el-col :span="25" v-for="item of ZanWorkList" :key="item.id">
                          <el-card shadow="never">
                            <div class="worklist">
                              <div class="worklist_imgwrapper" @click="LookWork(item)">
                                <el-image class="workimg" :src="item.covers" fit="fill"></el-image>
                              </div>

                              <div class="work_title">
                                <el-tooltip class="item" effect="dark" :content="item.title" placement="top-start">
                                  <span class="work_title_span">{{
                                    item.title.slice(0, 10)
                                  }}</span>
                                </el-tooltip>
                                <br />
                                <span style="margin-left: 5px" class="el-icon-thumb">
                                  <span style="margin-left: 5px">{{
                                    item.zan
                                  }}</span>
                                </span>
                                <span style="margin-left: 10px" class="el-icon-view"><span style="margin-left: 5px">{{
                                    item.looks
                                  }}</span></span>
                              </div>

                              <div>
                                <el-row>
                                  <el-col :span="4">
                                    <div class="work_stuinfo">
                                      <el-avatar size="small" class="work_stuinfo_avatar" :src="item.headImgUrl">
                                      </el-avatar>
                                    </div>
                                  </el-col>
                                  <el-col :span="8">
                                    <div class="work_stuinfo_name">
                                      <span class="work_stuinfo_name_span">{{
                                        item.name
                                      }}</span>
                                    </div>
                                  </el-col>
                                </el-row>
                              </div>
                            </div>
                          </el-card>
                        </el-col>
                      </el-row>
                      <wgStuEmpty v-else />

                      <div style="margin: 20px; text-align: right">
                        <el-pagination @current-change="handleCurrentChange2" :current-page="page_no2" :page-size="page_size2" layout="total, prev, pager, next, jumper" :total="total2">
                        </el-pagination>
                      </div>
                    </el-tab-pane>

                    <el-tab-pane v-if="zone_auth" label="收藏" name="fourth">
                      <el-form ref="form" :model="KeepworkForm" :inline="true" size="mini">
                        <el-form-item label="所属科目">
                          <el-select v-model="KeepworkForm.subject_code" placeholder="请选择科目" style="width: 100px" filterable @change="getUserKeepWorkList">
                            <el-option :label="item.name" :value="item.code" v-for="(item, index) of subjectList" :key="index"></el-option>
                          </el-select>
                        </el-form-item>

                        <el-form-item label="作品名称">
                          <el-input clearable style="width: 200px" v-model="KeepworkForm.title" placeholder="请输入作品名称">
                          </el-input>
                        </el-form-item>

                        <el-form-item size="mini">
                          <el-button type="primary" @click="getUserKeepWorkList">查询</el-button>
                        </el-form-item>
                      </el-form>

                      <el-row :gutter="20" v-if="KeepWorkList.join('') !== ''">
                        <el-col :span="25" v-for="item of KeepWorkList" :key="item.id">
                          <el-card shadow="never">
                            <div class="worklist">
                              <div class="worklist_imgwrapper" @click="LookWork(item)">
                                <el-image class="workimg" :src="item.covers" fit="fill"></el-image>
                              </div>

                              <div class="work_title">
                                <el-tooltip class="item" effect="dark" :content="item.title" placement="top-start">
                                  <span class="work_title_span">{{
                                    item.title.slice(0, 10)
                                  }}</span>
                                </el-tooltip>
                                <br />
                                <span style="margin-left: 5px" class="el-icon-thumb">
                                  <span style="margin-left: 5px">{{
                                    item.zan
                                  }}</span>
                                </span>
                                <span style="margin-left: 10px" class="el-icon-view"><span style="margin-left: 5px">{{
                                    item.looks
                                  }}</span></span>
                              </div>

                              <div>
                                <el-row>
                                  <el-col :span="4">
                                    <div class="work_stuinfo">
                                      <el-avatar size="small" class="work_stuinfo_avatar" :src="item.headImgUrl">
                                      </el-avatar>
                                    </div>
                                  </el-col>
                                  <el-col :span="8">
                                    <div class="work_stuinfo_name">
                                      <span class="work_stuinfo_name_span">{{
                                        item.name
                                      }}</span>
                                    </div>
                                  </el-col>
                                </el-row>
                              </div>
                            </div>
                          </el-card>
                        </el-col>
                      </el-row>
                      <wgStuEmpty v-else />

                      <div style="margin:20px 20px 0; text-align: right">
                        <el-pagination @current-change="handleCurrentChange3" :current-page="page_no3" :page-size="page_size3" layout="total, prev, pager, next, jumper" :total="total3">
                        </el-pagination>
                      </div>
                    </el-tab-pane>
                  </el-tabs>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>

      <!--点评作业弹窗-->
      <el-dialog class="comment" title="课堂作品" :visible.sync="dialogFormVisible" top="5vh" width="80%">
        <el-row>
          <el-col :span="14">
            <div class="grid-content bg-purple">
              <el-row>
                <el-col :span="24">
                  <div style="font-size: 16px; font-weight: 500" class="grid-content bg-purple-dark">
                    {{ work_title }}
                  </div>
                </el-col>
              </el-row>

              <el-row style="margin-top: 10px">
                <el-col :span="9">
                  <div style="line-height: 30px" class="grid-content bg-purple">
                    <span style="font-size: 12px">
                      发布于：{{ workinfo.created_time }}</span>
                  </div>
                </el-col>
                <el-col :span="9">
                  <div style="line-height: 30px" class="grid-content bg-purple-light">
                    <span style="font-size: 12px">
                      更新于：{{ workinfo.update_time }}</span>
                  </div>
                </el-col>
              </el-row>

              <iframe style="margin-top: 10px; border: 0px" :src="
                  '/scratch/player.html?work_title=' +
                    work_title +
                    '&work_url=' +
                    work_url +
                    '&scale=' +
                    scale
                " :width="frameWidth" :height="frameHeight"></iframe>

              <el-row>
                <el-col :span="24">
                  <div style="font-size: 14px; margin-top: 10px" class="grid-content bg-purple-dark">
                    <ul>
                      <el-button style="margin-right: 20px; cursor: pointer" class="el-icon-view" type="text" @click="LookCode">查看源码</el-button>
                      <el-popover placement="top-start" title="手机分享" width="150" trigger="click" content="手机分享作品，赶快体验吧!">
                        <div id="qrcodeImg"></div>
                        <el-button @click="qrcode" type="text" slot="reference" style="margin-right: 20px; cursor: pointer" class="el-icon-share">分享</el-button>
                      </el-popover>
                    </ul>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple-light">
              <el-row>
                <el-col :span="24">
                  <div style="font-size: 16px; font-weight: 500" class="grid-content bg-purple-dark">
                    老师点评
                  </div>
                </el-col>
              </el-row>

              <el-form :model="markform" ref="ruleForm" label-width="100px" label-position="top" size="mini" style="margin-top: 10px" class="demo-ruleForm">
                <el-form-item label="作品等级" prop="markpoint">
                  <el-rate disabled v-model="markform.markpoint"> </el-rate>
                </el-form-item>
                <el-form-item label="作品推优" prop="is_good">
                  <el-switch disabled v-model="markform.is_good"></el-switch>
                </el-form-item>
                <el-form-item label="教师评语" prop="remark">
                  <span style="margin-top: 10px"> {{ markform.remark }}</span>
                </el-form-item>
              </el-form>
            </div>
          </el-col>
        </el-row>
      </el-dialog>

      <!--PYTHON点评作业弹窗-->
      <el-dialog class="comment" title="课堂作品" :visible.sync="dialogFormVisible2" top="5vh" width="80%">
        <el-row>
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <el-row>
                <el-col :span="24">
                  <div style="font-size: 16px; font-weight: 500" class="grid-content bg-purple-dark">
                    {{ work_title }}
                  </div>
                </el-col>
              </el-row>

              <el-row style="margin-top: 10px">
                <el-col :span="9">
                  <div style="line-height: 30px" class="grid-content bg-purple">
                    <span style="font-size: 12px">
                      发布于：{{ workinfo.created_time }}</span>
                  </div>
                </el-col>
                <el-col :span="9">
                  <div style="line-height: 30px" class="grid-content bg-purple-light">
                    <span style="font-size: 12px">
                      更新于：{{ workinfo.update_time }}</span>
                  </div>
                </el-col>
              </el-row>
              <iframe style="margin-top: 10px; border: 0px" :src="python_work_url" :width="frameWidth2" :height="frameHeight2"></iframe>
            </div>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <div class="grid-content bg-purple-light">
              <el-row>
                <el-col :span="24">
                  <div style="font-size: 16px; font-weight: 500" class="grid-content bg-purple-dark">
                    老师点评
                  </div>
                </el-col>
              </el-row>

              <el-form :model="markform" ref="ruleForm" label-width="100px" :inline="true" size="mini" style="margin-top: 10px" class="demo-ruleForm">
                <el-form-item label="作品等级" prop="markpoint">
                  <el-rate disabled v-model="markform.markpoint"> </el-rate>
                </el-form-item>
                <el-form-item label="作品推优" prop="is_good">
                  <el-switch disabled v-model="markform.is_good"></el-switch>
                </el-form-item>
                <el-form-item label="教师评语" prop="remark">
                  <span style="margin-top: 10px"> {{ markform.remark }}</span>
                </el-form-item>
              </el-form>
            </div>
          </el-col>
        </el-row>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { stuGetTchWorkList } from '@/api/classroom/student_api'

import wgStuEmpty from '@/components/wgStuEmpty'
import {
  getWorkList,
  getUserZanWorkList,
  getUserKeepWorkList,
  deleteScWork,
  deleteJrWork,
  deletePyWork,
  stuGetStuWorkSubject,
  getZoneSchoolSubjectList,
} from '@/api/community'

import QRCode from 'qrcodejs2' // 引入qrcode

export default {
  name: 'freeCreation',
  components: {
    [wgStuEmpty.name]: wgStuEmpty,
  },
  data() {
    return {
      value: null,
      ruleForm: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
      },
      rules: {
        name: [
          { required: true, message: '请输入活动名称', trigger: 'blur' },
          { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' },
        ],
        region: [
          { required: true, message: '请选择活动区域', trigger: 'change' },
        ],
        date1: [
          {
            type: 'date',
            required: true,
            message: '请选择日期',
            trigger: 'change',
          },
        ],
        date2: [
          {
            type: 'date',
            required: true,
            message: '请选择时间',
            trigger: 'change',
          },
        ],
        type: [
          {
            type: 'array',
            required: true,
            message: '请至少选择一个活动性质',
            trigger: 'change',
          },
        ],
        resource: [
          { required: true, message: '请选择活动资源', trigger: 'change' },
        ],
        desc: [{ required: true, message: '请填写活动形式', trigger: 'blur' }],
      },
      dialogFormVisible: false,
      dialogFormVisible2: false,
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
      },
      formLabelWidth: '120px',

      activeName: 'second',
      radio1: '上海',
      radio: '3',
      sizeForm: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
      },
      StuCourseWorks: [],
      FreeWorkList: [], //自由创作作品
      markform: {},
      work_title: '',
      work_url: '',
      workinfo: {},

      subjectList: [], //校区科目列表

      CourseworkForm: {
        subject_code: '',
        is_marking: '',
        title: '',
      },

      FreeworkForm: {
        subject_code: '',
        is_marking: '',
        title: '',
      },

      ZanworkForm: {
        subject_code: '',
        is_marking: '',
        title: '',
      },
      KeepworkForm: {
        subject_code: '',
        is_marking: '',
        title: '',
      },

      ZanWorkList: [],
      KeepWorkList: [],

      //课堂作品列表
      page_no: 1,
      page_size: 20,
      total: 0,
      //自由创作作品列表
      page_no1: 1,
      page_size1: 20,
      total1: 0,
      //已赞作品列表
      page_no2: 1,
      page_size2: 20,
      total2: 0,
      //已收藏作品列表
      page_no3: 1,
      page_size3: 20,
      total3: 0,

      //作品尺寸适配
      frameWidth: 0, // 屏幕宽
      frameHeight: 0, // 屏幕高
      scale: 0,

      frameWidth1: 0, // 屏幕宽
      frameHeight1: 0, // 屏幕高

      frameWidth2: 0, // 屏幕宽
      frameHeight2: 0, // 屏幕高

      python_work_url: '',

      //科目权限
      jr_show: false,
      sc_show: false,
      python_show: false,
      cplus_show: false,
      zone_auth: true,
      schoolIdTest: '',
      stuTchPlanIdTest: ''
    }
  },

  async mounted() {
    this.freshDataType()
    await this.stuGetStuWorkSubject()
    this.getWorkList()

    console.log('IFRAME 宽度')
    console.log(this.screenWidth)

    this.frameWidth = document.documentElement.clientWidth * 0.8 * 0.583 - 50
    this.frameHeight = this.frameWidth * 0.75 + 55

    this.frameWidth1 = document.documentElement.clientWidth * 0.8 - 50
    this.frameHeight1 = this.frameWidth1 * 0.5 + 55

    this.frameWidth2 = document.documentElement.clientWidth * 0.8 - 50
    this.frameHeight2 = this.frameWidth2 * 0.5 + 55

    this.scale = this.frameWidth / 480
  },

  methods: {
    // res.userInfo.zoneAuth === false
    freshDataType() {
      this.$store.dispatch('freshUserData').then((res) => {
        this.zone_auth = res.userInfo.zoneAuth
      })
    },
    handleCurrentChange(val) {
      this.page_no = val
      this.stuGetTchWorkList()
    },

    handleCurrentChange1(val) {
      this.page_no1 = val
      this.getWorkList()
    },

    handleCurrentChange2(val) {
      this.page_no2 = val
      this.getUserZanWorkList()
    },

    handleCurrentChange3(val) {
      this.page_no3 = val
      this.getUserZanWorkList()
    },

    //查询校区科目权限
    async getZoneSchoolSubjectList() {
      return getZoneSchoolSubjectList().then((res) => {
        console.log('获得校区科目列表')
        console.log(res)
        this.subjectList = res.subjectList
        this.CourseworkForm.subject_code = res.subjectList[0].code
        this.FreeworkForm.subject_code = res.subjectList[0].code
        this.ZanworkForm.subject_code = res.subjectList[0].code
        this.KeepworkForm.subject_code = res.subjectList[0].code
      })
    },

    //查询校区科目权限
    async stuGetStuWorkSubject() {
      return stuGetStuWorkSubject().then((res) => {
        console.log('获得校区科目列表')
        console.log(res)
        if (res.subjectList && res.subjectList.join('') !== '') {
          this.subjectList = res.subjectList
          this.CourseworkForm.subject_code = res.subjectList[0].code
          this.FreeworkForm.subject_code = res.subjectList[0].code
          this.ZanworkForm.subject_code = res.subjectList[0].code
          this.KeepworkForm.subject_code = res.subjectList[0].code
        }
      })
    },

    //获得学生自由创作列表
    getWorkList() {
      getWorkList({
        subject_code: this.FreeworkForm.subject_code,
        title: this.FreeworkForm.title,
        page_no: this.page_no1,
        page_size: this.page_size1,
      }).then((res) => {
        console.log('查询学生自由创作列表')
        console.log(res)
        this.FreeWorkList = res.workList
        this.total1 = res.total
      })
    },

    //获得点赞作品列表
    getUserZanWorkList() {
      getUserZanWorkList({
        subject_code: this.ZanworkForm.subject_code,
        title: this.ZanworkForm.title,
        page_no: this.page_no2,
        page_size: this.page_size2,
      }).then((res) => {
        console.log('查询点赞作品列表')
        console.log(res)
        this.ZanWorkList = res.workList
        this.total2 = res.total
      })
    },

    //获得收藏作品列表
    getUserKeepWorkList() {
      getUserKeepWorkList({
        subject_code: this.KeepworkForm.subject_code,
        title: this.KeepworkForm.title,
        page_no: this.page_no3,
        page_size: this.page_size3,
      }).then((res) => {
        console.log('查询收藏作品列表')
        console.log(res)
        this.KeepWorkList = res.workList
        this.total3 = res.total
      })
    },

    //跳转到作品详情页面
    LookWork(item) {
      console.log('跳转到作品详情页面')
      console.log(item)

      this.stuTchPlanIdTest = item.stu_tch_plan_id
      this.schoolIdTest = item.educational_institution_id
      if (this.activeName == 'second') {
        console.log('自由创作作品列表')
        if (this.FreeworkForm.subject_code == '1') {
          console.log('自由创作-Jrcode')

          window.location.href =
            '/jrcode/create.html?mode=edit&filepath=' +
            item.work_url +
            '&work_id=' +
            item.id +
            '&work_type=1&subject_code=1&operate=edit'
        } else if (this.FreeworkForm.subject_code == '2') {
          console.log(444545, 7545412)
          console.log('自由创作-Scratch')
          this.$store.dispatch('freshUserData').then((res) => {
            console.log(res, 145412)
            if (res.identity === 2) {
              window.location.href =
                '/community/project?work_id=' +
                item.id +
                '&subject_code=' +
                this.FreeworkForm.subject_code +
                '&path=classlistStuWorks'
            }
            if (res.identity === 1) {
              if (item.work_type == '2') {
                window.location.href =
                  '/community/project?work_id=' +
                  item.id +
                  '&subject_code=' +
                  this.FreeworkForm.subject_code +
                  '&path=classlistStuWorks'
              } else {
                this.$message.warning('请先发布作品!')
              }
            }
          })
        } else if (this.FreeworkForm.subject_code == '3') {
          console.log('python作品编辑')
          console.log(item)
          console.log(item.id)

          if (localStorage.getItem('current_py_version') == 'v2') {
            window.open('/python/editor_v2?work_id=' + item.id + '&mode=edit')
          } else if (localStorage.getItem('current_py_version') == 'v1') {
            window.open('/python/editor?work_id=' + item.id + '&mode=edit')
          } else {
            window.open('/python/editor_v2?work_id=' + item.id + '&mode=edit')
          }
        }
      } else if (this.activeName == 'third') {
        if (this.ZanworkForm.subject_code == '1') {
          console.log('点赞作品-Jrcode')
          window.open(
            '/jrcode/show.html?mode=look&filepath=' +
            item.work_url +
            '&work_id=' +
            item.id
          )
        } else if (this.ZanworkForm.subject_code == '2') {
          console.log('点赞作品-Scratch')
          let routeData = this.$router.resolve({
            path: '/community/project',
            query: {
              work_id: item.id,
              subject_code: this.ZanworkForm.subject_code,
            },
          })
          window.open(routeData.href, '_blank')
        } else if (this.ZanworkForm.subject_code == '3') {
          console.log('python作品编辑')
          console.log(item)
          console.log(item.id)
          window.open('/python/editor?work_id=' + item.id + '&mode=look')
        }
      } else if (this.activeName == 'fourth') {
        if (this.KeepworkForm.subject_code == '1') {
          console.log('收藏作品-Jrcode')
          window.open(
            '/jrcode/show.html?mode=look&filepath=' +
            item.work_url +
            '&work_id=' +
            item.id
          )
        } else if (this.KeepworkForm.subject_code == '2') {
          console.log('收藏作品-Scratch')
          let routeData = this.$router.resolve({
            path: '/community/project',
            query: {
              work_id: item.id,
              subject_code: this.KeepworkForm.subject_code,
            },
          })
          window.open(routeData.href, '_blank')
        } else if (this.KeepworkForm.subject_code == '3') {
          console.log('python作品编辑')
          console.log(item)
          console.log(item.id)
          window.open('/python/editor?work_id=' + item.id + '&mode=look')
        }
      }

      /* this.$router.push({
        name: "community-project",
        query: {
          work_id: item.id,
        },
      });*/
    },

    stuGetTchWorkList() {
      stuGetTchWorkList({
        subject_code: this.CourseworkForm.subject_code,
        title: this.CourseworkForm.title,
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log('查询学生课堂作品及作业')
        console.log(res)
        this.StuCourseWorks = res.workList
        this.total = res.total
      })
    },

    //删除自由创作作品
    deleteWork(id) {
      this.$confirm('确定删除该作品吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        if (this.activeName == 'second') {
          if (this.FreeworkForm.subject_code == '1') {
            console.log('删除JRCODE 自由创作作品')
            deleteJrWork({
              work_id: id,
            }).then((res) => {
              console.log('删除JR作品')
              console.log(res)
              if (res.is_delete) {
                this.$message.success('删除成功')
                this.getWorkList()
              }
            })
          } else if (this.FreeworkForm.subject_code == '2') {
            console.log('删除SCRATCH 自由创作作品')
            deleteScWork({
              work_id: id,
            }).then((res) => {
              console.log('删除SC作品')
              console.log(res)
              if (res.is_delete) {
                this.$message.success('删除成功')
                this.getWorkList()
              }
            })
          } else if (this.FreeworkForm.subject_code == '3') {
            console.log('删除Python自由作品')
            deletePyWork({
              work_id: id,
            }).then((res) => {
              console.log('删除python作品')
              if (res.is_delete) {
                this.$message.success('删除成功')
                this.getWorkList()
              }
            })
          }
        }
      })
    },

    onSubmit() {
      console.log('submit!')
    },
    async handleClickTab(tab, event) {
      console.log(tab, event)
      // if (this.activeName == 'first') {
      //   this.stuGetTchWorkList()
      // } else
      this.subjectList = []
      this.CourseworkForm.subject_code = ''
      this.FreeworkForm.subject_code = ''
      this.ZanworkForm.subject_code = ''
      this.KeepworkForm.subject_code = ''
      if (this.activeName == 'second') {
        await this.stuGetStuWorkSubject()
        this.getWorkList()
      } else if (this.activeName == 'third') {
        await this.getZoneSchoolSubjectList()
        this.getUserZanWorkList()
      } else if (this.activeName == 'fourth') {
        await this.getZoneSchoolSubjectList()
        this.getUserKeepWorkList()
      }
    },
    handleClick(row) {
      console.log(row)
    },

    handleEdit(row) {
      this.dialogFormVisible = true
      console.log(row)
    },
    handleClassClick() {
      console.log('班级信息')
      this.$router.push({
        name: 'classlistDescTeacher',
      })
    },

    qrcode() {
      document.getElementById('qrcodeImg').innerHTML = ''

      new QRCode('qrcodeImg', {
        width: 150,
        height: 150,
        text:
          'https://steam.fun/scratch/h5player.html?work_type=2&work_id=' +
          this.workinfo.id +
          '&subject_code=2' + `&stuTchPlanIdTest=${this.stuTchPlanIdTest}&schoolIdTest=${this.schoolIdTest}`, // 二维码地址
        colorDark: '#000',
        colorLight: '#fff',
      })
    },

    LookCode() {
      console.log('学生查看课堂作品源码')

      if (this.workinfo.work_type == '1') {
        window.location.href =
          '/scratch/course.html?plan_id=' +
          this.workinfo.stu_tch_plan_id +
          '&operate=2'
      } else if (this.workinfo.work_type == '2') {
        window.location.href =
          '/scratch/course.html?plan_id=' +
          this.workinfo.stu_tch_plan_id +
          '&operate=4'
      }
    },

    //编辑自由创作作品
    EditCode(item) {
      console.log('编辑自由创作作品')

      if (this.activeName == 'second') {
        console.log('自由创作作品列表')
        if (this.FreeworkForm.subject_code == '1') {
          console.log('自由创作-Jrcode')

          window.location.href =
            '/jrcode/create.html?mode=edit&filepath=' +
            item.work_url +
            '&work_id=' +
            item.id +
            '&work_type=1&subject_code=1&operate=edit'
        } else if (this.FreeworkForm.subject_code == '2') {
          window.location.href =
            '/scratch/index.html?work_type=1&work_id=' +
            item.id +
            '&subject_code=2&operate=edit'
        } else if (this.FreeworkForm.subject_code == '3') {
          console.log('python作品编辑')
          console.log(item)
          console.log(item.id)

          window.location.href = '/python/editor?work_id=' + item.id
        }
      }
    },
  },
}
</script>

<style>
.el-dialog {
  width: 900px;
}
</style>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  padding: 20px;
}
.school-body-stu-works {
  height: 100%;
  & > .el-row {
    height: 100%;
    .el-col {
      height: 100%;
    }
  }
  .classwrapper {
    box-sizing: border-box;
    height: 100%;
    border-radius: 15px;
    overflow-y: auto;
    background: white;
    padding: 20px;
    .el-col-25 {
      width: 20%;
      margin-bottom: 20px;
    }

    .worklist {
      background: white;
      border-radius: 15px;
      padding-bottom: 10px;
      .worklist_imgwrapper {
        width: 100%;
        height: 0;
        padding-bottom: 75%;
        cursor: pointer;

        .workimg /deep/ {
          box-sizing: border-box;
          width: 100%;
          padding: 10px;
          img {
            border-radius: 10px;
          }
        }
      }

      .work_title {
        padding-top: 10px;
        margin-left: 5px;

        .work_title_span {
          font-size: 14px;
          color: #606266;

          width: 90%;
          overflow: hidden;
          /*内容超出后隐藏*/
          text-overflow: ellipsis;
          /* 超出内容显示为省略号 */
          white-space: nowrap;
          /* 文本不进行换行 */
        }
      }

      .work_stuinfo {
        margin-left: 5px;

        .work_stuinfo_avatar {
          float: left;
        }
      }

      .work_stuinfo_name {
        .work_stuinfo_name_span {
          margin-left: 5px;
          line-height: 30px;
        }
      }
    }
  }

  .classwrapper::-webkit-scrollbar {
    display: none;
  }
}
</style>

<style>
.school-body-stu-works .el-card__body {
  padding: 0px;
}
</style>
